import { render, staticRenderFns } from "./groupTab.vue?vue&type=template&id=b852f16a&"
import script from "./groupTab.vue?vue&type=script&lang=js&"
export * from "./groupTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b852f16a')) {
      api.createRecord('b852f16a', component.options)
    } else {
      api.reload('b852f16a', component.options)
    }
    module.hot.accept("./groupTab.vue?vue&type=template&id=b852f16a&", function () {
      api.rerender('b852f16a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/guarantee/groupTab.vue"
export default component.exports